import { Button } from "semantic-ui-react"
import { ReactComponent as PiggyBank } from "../../../images/piggy-bank.svg"
import { withRouter } from "react-router"
import { routerPaths } from "../../../v1/constants/paths"
import { isEbayUser } from "../../../v1/helpers/affiliationHelpers"
import { connect } from "react-redux"
import { isCanada } from "../../../v1/helpers/translationHelpers"
import { useEffect } from "react"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const UpsellMembershipBanner = ({ title, history, style, user, activeOrder }) => {
  const showBanner = () => {
    if (
      isEbayUser(user) ||
      user?.total_shop_orders === 0 ||
      user?.membership?.plan_name !== "Basic" ||
      activeOrder ||
      isCanada(user?.country)
    )
      return false
    return true
  }

  useEffect(() => {
    if (showBanner()) {
      try {
        trackFirebaseAnalytics({
          event: gaJSON.premium_upsell_interaction,
          params: {
            interaction_type: "view",
            ui_location: window.location.hash.includes("dashboard")
              ? "dashboard_banner"
              : "mini_review_text"
          }
        })
      } catch (error) {
        console.error(error)
      }
    }
  }, [])

  const upgradeToPremiumBtnClick = () => {
    try {
      trackFirebaseAnalytics({
        event: gaJSON.premium_upsell_interaction,
        params: {
          interaction_type: "click",
          ui_location: window.location.hash.includes("dashboard")
            ? "dashboard_banner"
            : "mini_review_text"
        }
      })
      history.push(routerPaths.upsellMembership)
    } catch (error) {
      console.error(error)
    }
  }

  if (!showBanner()) return null

  return (
    <div className="upsell-membership-banner" style={{ ...style }}>
      <p className="banner-title">{title ?? "Save Big: $400 a Year on Average!"}</p>

      <Button className="banner-cta" onClick={upgradeToPremiumBtnClick}>
        Upgrade to Premium
      </Button>

      <div className="banner-icon">
        <PiggyBank width={43} height={45} />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  let user = state.user || {}
  let activeVehicleIndex = -1
  if (user.activeVehicleId) {
    activeVehicleIndex = user.vehicles.findIndex((v) => v.id === user.activeVehicleId)
  }
  let activeVehicle = (user.vehicles && user.vehicles[activeVehicleIndex]) || {}
  let activeOrder =
    activeVehicle &&
    activeVehicle.id &&
    (state.orders.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)

  return {
    user,
    activeOrder
  }
}
export default withRouter(connect(mapStateToProps)(UpsellMembershipBanner))
